import * as React from 'react';

import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import SidePanel from 'src/components/sidePanel/SidePanel';
import ParkingSidePanel from 'src/features/parkingManagement/components/ParkingSidePanel';
import { useMediaQuery } from 'src/hooks/use-media-query';
import { Dialog, DialogContent } from 'src/registry/ui/Dialog';

const ParkingLayout = () => {
    const isMobile = useMediaQuery('(max-width: 639px)');
    return (
        <div className="relative">
            {isMobile ? (
                <SidePanel name="parking-management-side-panel" variant="leftSheet">
                    <ParkingSidePanel />
                </SidePanel>
            ) : (
                <Dialog modal={false} open>
                    <DialogContent variant="leftSheetStatic" showCloseButton={false} className="overflow-y-auto">
                        <ParkingSidePanel />
                    </DialogContent>
                </Dialog>
            )}
            <MainLayout>
                <Outlet />
            </MainLayout>
        </div>
    );
};

export default ParkingLayout;
